module.exports = __webpack_public_path__ + "img/multiSlectedEle.9956bf2f.svg";